
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.077 27.6l-3.5-12.05a4.489 4.489 0 001.39-3.55c0-2.27-1.12-4-2.59-4h-25.09c-1.48 0-2.6 1.72-2.6 4 0 2.05.91 3.63 2.16 3.93l-2.84 11.21c-.01.083-.01.167 0 .25v22.72a1 1 0 001 1h31.14a.85.85 0 00.39-.08c.124-.05.236-.125.33-.22a.528.528 0 00.06-.1c.056-.067.104-.14.14-.22a1.755 1.755 0 000-.22V27.89a.9.9 0 00.01-.29zm-4.72-17.57a2.63 2.63 0 01.61 2 2.71 2.71 0 01-.6 2 2.77 2.77 0 01-.59-2 2.83 2.83 0 01.58-2zm-25.67 2a2.668 2.668 0 01.62-2h22.79a6.15 6.15 0 00-.32 2c-.007.68.105 1.358.33 2h-22.78a2.582 2.582 0 01-.64-2.03v.03zm21.58 15.65a.852.852 0 000 .23v21.23h-22.26v-21.6l2.92-11.52h22.2l-2.86 11.66zm3.46 21.46l.95-.9 1 .9h-1.95zm3.39-1.34l-1.44-1.37v-17.4a1 1 0 10-2 0v17.4l-1.44 1.37V28.03l2.22-9.13 2.66 9.15V47.8z"}})])
          )
        }
      }
    